import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { IotaModalOptions, IotaModalSize, MAT_DIALOG_DATA, MatDialogRef } from '@iota/iota-ui-components';
import { DisplayableImageContentTypes } from '../../constants-and-enums/image-types';
import { getHeroFileIcon } from 'src/app/shared/utils';

export interface DialogUploadDocumentData {
    title?: string;
    text?: string;
    multiple?: boolean;
}

@Component({
    standalone: false,
    selector: 'app-dialog-upload-document',
    templateUrl: './dialog-upload-document.component.html',
    styleUrls: ['./dialog-upload-document.component.scss']
})
export class DialogUploadDocumentComponent {
    public modalOptions: Partial<IotaModalOptions> = {
        size: IotaModalSize.MEDIUM,
        showToggleFullScreenButton: false
    };

    @ViewChild('fileDropRef', { static: false }) fileDropEl: ElementRef;

    files: File[] = [];

    filePreviews = new Map<string, any>();

    constructor(
        private dialogRef: MatDialogRef<DialogUploadDocumentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogUploadDocumentData
    ) {}

    getDocumentExtension(document: File): string {
        return document?.name.split('.').slice(-1).join('');
    }

    previewAvailable(file: File): boolean {
        return DisplayableImageContentTypes.includes((file as Blob).type);
    }

    onFilesSelected(files: FileList): void {
        if (!this.data?.multiple) {
            this.filePreviews.clear();
            this.files.splice(0);
        }

        const length = this.data?.multiple ? files.length : 1;

        for (let i = 0; i < length; i++) {
            const file = files.item(i);
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.filePreviews.set(file.name, reader.result);
            };

            this.files.push(file);
        }
    }

    onSelectClick(): void {
        this.fileDropEl.nativeElement.click();
    }

    removeFile(index: number, file: File): void {
        this.files.splice(index, 1);
        this.filePreviews.delete(file.name);
    }

    save() {
        this.dialogRef.close({ files: this.files });
    }

    isValid() {
        return this.files.length > 0;
    }

    close() {
        this.dialogRef.close();
    }

    protected readonly getHeroFileIcon = getHeroFileIcon;
}
